import React from "react";

class PuzzleCGU extends React.Component {

    constructor({...props}, context) {
        super();
    };

    render() {
        return (
            <div style={{padding: "20%", paddingTop: "15px", color: "white"}}>
                <h1>Pièce du Puzzle</h1>
                <div>
                    <img width={"100%"} height={"auto"} src={"/public/anniv/2025/puzzle_castle_2.png"}/>
                </div>
                <div style={{height: "80vh"}}/>
            </div>
        );
    };

    /*

    */

};

export default PuzzleCGU;
